export const arabicLocales = {
  validation: {
    required: 'مطلوب',
  },
  agree_to_terms: 'الموافقة على الشروط والاحكام',
  required: 'مطلوب',
  SITE_NAME: 'راسل',
  dashboard: 'لوحة التحكم',
  home: 'الصفحة الرئيسية',
  login: 'تسجبل الدخول',
  login_description: 'سجل دخولك الان ابدأ في استخدام <strong>راسل</strong>',
  register_description: 'سجل حسابك الان وابدأ في استخدام <strong>راسل</strong>',
  email: 'بريدك الالكتروني',
  password: 'كلمة المرور',
  login_button_text: 'سجل دخول',
  loading_text: 'Please wait...',
  full_name: 'الاسم بالكامل',
  phone: 'رقم الهاتف',
  password_confirmation: 'تأكيد كلمة المرور',
  register_button_text: 'سجل الان',
  register: 'تسجيل  جديد',
  have_an_account: 'لديك حساب بالفعل؟',
  not_have_an_account: 'ليس لديك حساب معنا؟',
  remember_an_account: ' هل تذكرت كلمة المرور ؟',
  forget_password: 'استعادة كلمة المرور',
  forget_button_text: 'استعادة كلمة المرور',
  forget_password_description: 'استعد كلمة المرور وابدأ في استخدام <strong>راسل</strong>',
  confirm_button_text: 'تأكيد',
  resend_in: 'اعادة ارسال في :timerث',
  resend_code: 'اعادة ارسال رمز التأكيد',
  verification_code_sent: 'تم ارسال الكود',
  error_sending_code: 'حدث خطأ اثناء الارسال ... حاول مرة اخرى',
  verify_registration: 'تأكيد حسابك',
  verify_login: 'تأكيد حسابك',
  verify_registration_description: 'تم ارسال رمز التأكيد عبر الواتس آب الخاص بك',
  verify_login_description: 'تم ارسال رمز التأكيد عبر الواتس آب الخاص بك',
  alert_verify_login_description: 'حسابك غير مفعل لاستكمال الدخول يرجى ادخال رمز التأكيد',
  verify_account: 'تأكيد حسابك',
  verify_description: 'لقد أرسلنا رمز التحقق إلى بريدك الإلكتروني. يرجى إدخاله أدناه.',
  verification_code: 'رمز التحقق',
  enter_verification_code: 'أدخل رمز التحقق',
  didnt_receive_code: 'لم تستلم الرمز؟',
  terms_agreement: 'بالتسجيل، أنت توافق على',
  terms_and_conditions: 'الشروط والأحكام',
  remember_me: 'تذكرني',
  forgot_password: 'نسيت كلمة المرور؟',
  email_or_phone: 'البريد الإلكتروني أو رقم الهاتف',
  forgot_password_success: 'تم إرسال رابط إعادة تعيين كلمة المرور بنجاح',
  forgot_password_error: 'فشل في إرسال رابط إعادة تعيين كلمة المرور',
  verify_forgot_password: 'تأكيد إعادة تعيين كلمة المرور',
  verify_forgot_password_description:
    'لقد أرسلنا رمز التحقق إلى بريدك الإلكتروني/رقم هاتفك. يرجى إدخاله أدناه.',
  verify_code: 'تأكيد الرمز',
  verification_success: 'تم التحقق بنجاح',
  verification_error: 'فشل التحقق',
  reset_password: 'إعادة تعيين كلمة المرور',
  reset_password_description: 'أدخل كلمة المرور الجديدة أدناه',
  new_password: 'كلمة المرور الجديدة',
  confirm_new_password: 'تأكيد كلمة المرور الجديدة',
  reset_password_button: 'إعادة تعيين كلمة المرور',
  password_reset_success: 'تم إعادة تعيين كلمة المرور بنجاح',
  password_reset_error: 'فشل في إعادة تعيين كلمة المرور',
  remember_password: 'تذكرت كلمة المرور؟',
  or: 'أو',
  emailOrPhone: 'البريد الالكتروني او رقم الهاتف',
  customers: 'العملاء',
  filter: 'فلتر',
  reset: 'استعادة',
  create: 'إضافة',
  save: 'حفظ',
  delete: 'حذف',
  edit: 'تعديل',
  actions: 'التحكم',
  confirm: 'تأكيد',
  cancel: 'إلغاء',
  itemSaved: ' تم الحفظ بنجاح',
  noResults: 'لا توجد نتائج',
  networkError: 'خطأ في الشبكة',
  loading: 'جاري التحميل ...',
  deleteSuccess: 'تم الحذف بنجاح',
  confirmDeleteHeading: 'تأكيد الحذف',
  confirmDelete: 'هل أنت متأكد من أنك تريد حذف هذه :length سجلات؟',
  remove: 'حذف',
  update: 'تعديل',
  somethingWentWrong: 'حدثت مشكلة ما',
  packages: 'الباقات والاشتراكات',
  plans: 'الباقات',
  plan: 'الباقة',
  id: 'ID',
  name: 'الاسم',
  displaying: 'عرض',
  of: 'من',
  price: 'السعر',
  description: 'الوصف',
  invoice_interval: 'نوع مدة الاشتراك',
  invoice_period: 'مدة الاشتراك',
  trial_interval: 'نوع مدة الاشتراك التجريبية',
  sort_order: 'ترتيب الفرز',
  day: 'يوم',
  month: 'شهر',
  year: 'سنة',
  enabled_disabled: 'تفعيل / تعطيل',
  features: 'المميزات',
  general: 'عام',
  total_messages: 'اجمالي الرسائل',
  export_numbers: 'تصدير الأرقام ',
  link_api: 'الرابط والتكامل مع أي نظام عبر API',
  call_responder: 'Call Responder',
  chatbot: 'شات بوت',
  bulk_messaging_campaigns: 'Schedule by times',
  contact_groups: '  ارقام الجروبات',
  contact_numbers: 'عدد الأرقام',
  auto_responder: 'المجيب الآلي - الرد التلقائي',
  profile: 'الملف الشخصي',
  advertising_campaigns: 'الحملات الإعلانية',
  text_message: 'الرسائل النصية',
  address: 'العنوان',
  name_address: 'اسم المكان/العنوان',
  message: 'الرسالة',
  whatsapp_accounts: 'حسابات الواتس اب',
  add_whatsapp_account: 'اضافه حساب واتس اب',
  whatsapp: 'الواتس اب',
  start_connection: 'بدء الاتصال',
  loading_add_whatsapp_account: 'جاري اعداد الحساب .....',
  loading_whatsapp_account: 'جاري تحميل الحساب .....',
  loading_data: 'جاري تحميل البيانات .....',
  contacts: 'جهات الاتصال',
  integrations: 'التكاملات',
  salla_app: 'تطبيق سلة',
  salla_settings: 'إعدادات سلة',

  // WordPress Integration
  wordpress_integration: 'تكامل ووردبريس',
  wordpress_integration_description: 'دمج موقع ووردبريس الخاص بك مع لوحة تحكم راسل',
  download_wordpress_plugin: 'تحميل إضافة ووردبريس',
  wordpress_plugin_description:
    'ربط موقع ووردبريس الخاص بك بلوحة تحكم راسل لإدارة الحملات والعملاء والمزيد.',
  plugin_features: 'ميزات الإضافة',
  easy_integration: 'تكامل سهل',
  easy_integration_desc: 'عملية إعداد بسيطة بنقرات قليلة',
  customer_management: 'إدارة العملاء',
  customer_management_desc: 'إدارة عملاء ووردبريس مباشرة من لوحة تحكم راسل',
  campaign_integration: 'تكامل الحملات',
  campaign_integration_desc: 'إنشاء وإدارة الحملات لعملاء ووردبريس',
  analytics_tracking: 'التحليلات والتتبع',
  analytics_tracking_desc: 'تتبع سلوك العملاء وأداء الحملات',
  installation_guide: 'دليل التثبيت',
  installation_step_1: 'تحميل ملف الإضافة',
  installation_step_2: 'رفعه إلى موقع ووردبريس عبر الإضافات > إضافة جديدة > رفع إضافة',
  installation_step_3: 'تفعيل الإضافة',
  installation_step_4: 'تكوين بيانات اعتماد API من لوحة تحكم راسل',
  installation_step_5: 'ابدأ في إدارة عملائك وحملاتك!',
  download_now: 'تحميل الآن',
  version: 'الإصدار',
  last_updated: 'آخر تحديث',
  requirements: 'المتطلبات',
  requirement_1: 'ووردبريس 5.0 أو أحدث',
  requirement_2: 'PHP 7.4 أو أحدث',
  requirement_3: 'حساب لوحة تحكم راسل',
  plugin_information: 'معلومات الإضافة',
  need_help: 'هل تحتاج مساعدة؟',
  help_description:
    'إذا واجهت أي مشاكل أثناء التثبيت أو لديك أسئلة حول التكامل، يرجى الاتصال بفريق الدعم.',

  // Salla App Translations
  salla: {
    // General
    app_name: 'تطبيق سلة',
    settings: 'الإعدادات',
    overview: 'نظرة عامة',
    // abandoned_carts: 'العربات المهجورة',
    orders: 'الطلبات',
    customers: 'العملاء',
    reviews: 'التقييمات',
    admin_notifications: 'إشعارات الإدارة',
    widget_settings: 'إعدادات الويدجت',

    // Store Info
    store_name: 'اسم المتجر',
    store_id: 'معرف المتجر',
    store_url: 'رابط المتجر',
    visit_store: 'زيارة المتجر',

    // Actions
    refresh: 'تحديث',
    save_changes: 'حفظ التغييرات',
    save_all_changes: 'حفظ جميع التغييرات',
    edit: 'تعديل',
    cancel: 'إلغاء',
    save: 'حفظ',
    back_to_dashboard: 'العودة للوحة التحكم',
    add: 'إضافة',
    add_integration: 'إضافة تكامل',
    add_new_integration: 'إضافة تكامل جديد',

    // Status & Messages
    settings_updated: 'تم تحديث الإعدادات بنجاح!',
    no_changes: 'لا توجد تغييرات للحفظ',
    saving: 'جاري الحفظ...',
    refreshing: 'جاري التحديث...',
    loading: 'جاري التحميل...',
    no_settings_found: 'لم يتم العثور على إعدادات',

    // Tab Labels
    order_settings: 'إعدادات الطلبات',
    customer_settings: 'إعدادات العملاء',
    abandoned_carts_settings: 'السلات المتروكة',
    review_settings: 'إعدادات التقييمات',
    admin_notifications_settings: 'إشعارات الإدارة',
    widget_settings_label: 'إعدادات الويدجت',
    general_settings: 'الإعدادات العامة',

    // Setting Types
    enabled: 'مفعل',
    disabled: 'معطل',
    text: 'نص',
    number: 'رقم',
    select_option: 'اختر خيار',
    enter_text: 'أدخل النص...',
    enter_image_url: 'أدخل رابط الصورة...',
    enter_color_value: 'أدخل قيمة اللون...',

    // Input Labels
    input_label_text: 'إدخال النص',
    input_label_number: 'إدخال الرقم',
    input_label_select: 'إدخال الاختيار',
    input_label_switch: 'إدخال المفتاح',
    input_label_textarea: 'منطقة النص',
    input_label_image: 'إدخال الصورة',
    input_label_color: 'إدخال اللون',

    // Common Settings
    instance_id: 'معرف المثيل',
    access_token: 'رمز الوصول',
    message: 'الرسالة',
    image: 'الصورة',
    color: 'اللون',
    phone: 'الهاتف',
    url: 'الرابط',
    type: 'النوع',
    unit: 'الوحدة',
    position: 'الموضع',
    status: 'الحالة',
    value: 'القيمة',
    count: 'العدد',
    times: 'المرات',

    // Order Settings
    new_order: 'طلب جديد',
    payment_pending: 'انتظار الدفع',
    payment_method_cod: 'طريقة الدفع عند الاستلام',
    under_review: 'قيد المراجعة',
    in_progress: 'قيد التنفيذ',
    delivering: 'قيد التوصيل',
    delivered: 'تم التوصيل',
    shipped: 'تم الشحن',
    completed: 'مكتمل',
    canceled: 'ملغي',
    restoring: 'قيد الاستعادة',
    restored: 'تمت الاستعادة',
    request_quote: 'طلب عرض سعر',
    review: 'التقييم',
    review_trigger: 'مشغل التقييم',
    review_delay: 'تأخير التقييم',
    review_reminder: 'تذكير التقييم',

    // Customer Settings
    send_activation_code: 'إرسال رمز التفعيل',
    customer_otp: 'رمز التحقق للعميل',
    welcome_customer: 'ترحيب بالعميل',

    // Abandoned Carts
    abandoned_cart: 'السلة المتروكة',
    interval: 'الفترة الزمنية',

    // Campaigns
    campaigns: 'الحملات',
    manage_campaigns: 'إدارة الحملات',
    table_view_campaigns: 'عرض الحملات في جدول',
    create_campaign: 'إنشاء حملة',
    campaign: 'الحملة',
    progress: 'التقدم',
    statistics: 'الإحصائيات',
    created: 'تاريخ الإنشاء',
    campaign_name: 'اسم الحملة',
    campaign_name_required: 'اسم الحملة مطلوب',
    enter_campaign_name: 'أدخل اسم الحملة',
    send_to_all_abandoned_carts: 'إرسال لجميع السلات المتروكة',
    cart_ids: 'معرفات السلات',
    select_carts_or_send_to_all: 'يرجى تحديد معرفات السلات المحددة أو اختيار الإرسال للجميع',
    enter_cart_ids_comma_separated: 'أدخل معرفات السلات مفصولة بفواصل (مثل: 1001، 1002، 1003)',
    campaign_message: 'رسالة الحملة',
    enter_custom_message: 'أدخل رسالة مخصصة (اختياري)',
    notes: 'ملاحظات',
    enter_notes: 'أدخل ملاحظات (اختياري)',
    creating: 'جاري الإنشاء...',
    error_creating_campaign: 'خطأ في إنشاء الحملة',
    no_campaigns_found: 'لم يتم العثور على حملات',
    select_abandoned_carts: 'اختر السلات المتروكة',
    select_all: 'اختر الكل',
    search_carts: 'البحث في السلات حسب اسم العميل أو البريد الإلكتروني...',
    loading_carts: 'جاري تحميل السلات المتروكة...',
    no_carts_found: 'لم يتم العثور على سلات تطابق بحثك',
    no_abandoned_carts: 'لا توجد سلات متروكة متاحة',
    unknown_customer: 'عميل غير معروف',
    no_email: 'لا يوجد بريد إلكتروني',
    currency: 'ريال',
    abandoned_at: 'تم التخلي عنها في',
    selected_carts_count: 'تم اختيار :count سلة',
    page: 'صفحة',
    // Time filters and pagination
    time_filter: 'فلتر الوقت',
    last_7_days: 'آخر 7 أيام',
    last_30_days: 'آخر 30 يوم',
    last_90_days: 'آخر 90 يوم',
    items_per_page: 'العناصر في الصفحة',
    first_page: 'الصفحة الأولى',
    last_page: 'الصفحة الأخيرة',
    loading_campaigns: 'جاري تحميل الحملات...',
    search_campaigns: 'البحث في الحملات...',
    all_statuses: 'جميع الحالات',
    draft: 'مسودة',
    ready: 'جاهز',
    active: 'نشط',
    paused: 'متوقف مؤقتاً',
    // completed: 'مكتمل',
    failed: 'فشل',
    start: 'بدء',
    pause: 'إيقاف مؤقت',
    complete: 'إكمال',
    retry: 'إعادة المحاولة',
    start_campaign: 'بدء الحملة',
    pause_campaign: 'إيقاف الحملة مؤقتاً',
    complete_campaign: 'إكمال الحملة',
    retry_campaign: 'إعادة محاولة الحملة',
    // Additional campaign-related keys
    id_label: 'المعرف',
    total_campaigns: 'إجمالي الحملات',
    active_campaigns: 'الحملات النشطة',
    campaign_status_breakdown: 'توزيع حالات الحملات',
    performance_metrics: 'مقاييس الأداء',
    messages_sent: 'الرسائل المرسلة',
    messages_failed: 'الرسائل الفاشلة',
    messages_pending: 'الرسائل المعلقة',
    showing_page: 'عرض الصفحة',
    please_connect_salla_store: 'يرجى ربط متجر سلة أولاً',
    actions: 'الإجراءات',
    skipped: 'تم تخطيه',
    carts: 'السلات',
    sent: 'تم الإرسال',

    // Review Settings
    post_rating_feedback: 'تقييم ما بعد التقييم',
    excellent: 'ممتاز',
    very_good: 'جيد جداً',
    good: 'جيد',
    bad: 'سيء',
    coupon: 'كوبون',
    coupon_type: 'نوع الكوبون',
    coupon_value: 'قيمة الكوبون',
    max_discount: 'الخصم الأقصى',
    free_shipping: 'شحن مجاني',
    expires_in_days: 'ينتهي خلال أيام',
    percentage: 'نسبة مئوية',
    fixed: 'مبلغ ثابت',

    // Admin Notifications
    admin_new_order: 'إشعار إدارة الطلب الجديد',
    admin_low_stock: 'إشعار إدارة المخزون المنخفض',
    phones: 'الهواتف',

    // Widget Settings
    show_whatsapp_widget: 'إظهار ويدجت الواتساب',
    whatsapp_widget_logo: 'شعار ويدجت الواتساب',
    whatsapp_widget_phone: 'هاتف ويدجت الواتساب',
    default_message: 'الرسالة الافتراضية',
    show_status: 'إظهار الحالة',
    status_text: 'نص الحالة',
    qrcode_enabled: 'تفعيل رمز QR',
    popup_text: 'نص النافذة المنبثقة',
    button_text: 'نص الزر',
    margin: 'الهامش',
    button_size: 'حجم الزر',
    primary_color: 'اللون الأساسي',
    hover_color: 'لون التمرير',

    // Time Units
    hours: 'ساعات',
    days: 'أيام',
    weeks: 'أسابيع',
    months: 'أشهر',

    // Positions
    left: 'يسار',
    right: 'يمين',
    bottom: 'أسفل',
    top: 'أعلى',

    // Statuses
    // pending: 'قيد الانتظار',
    cancelled: 'ملغي',

    // Messages
    loading_salla_integrations: 'جاري تحميل تكاملات سلة...',
    store_not_found: 'لم يتم العثور على المتجر',
    no_integrations: 'لم يتم العثور على تكاملات سلة',
    no_integrations_found: 'لم يتم العثور على تكاملات سلة',
    no_integrations_yet: 'لا توجد تكاملات بعد',
    no_integrations_description:
      'قم بتوصيل متجر سلة الخاص بك لبدء إدارة السلات المتروكة والحملات والإعدادات.',
    visit_salla_apps: 'زيارة تطبيقات سلة',
    how_to_integrate: 'كيفية التكامل مع سلة',
    integration_step_1: 'قم بزيارة متجر تطبيقات سلة للعثور على تطبيقنا',
    integration_step_2: 'قم بتثبيت وتكوين التطبيق في متجر سلة الخاص بك',
    integration_step_3: 'عد إلى هنا لإدارة بيانات وإعدادات متجرك',
    error_fetching_integrations: 'خطأ في جلب التكاملات',
    error_fetching_settings: 'خطأ في جلب الإعدادات',
    error_updating_setting: 'خطأ في تحديث الإعداد',
    error_updating_settings: 'خطأ في تحديث الإعدادات',

    // Statistics
    total_carts: 'إجمالي السلات',
    total_value: 'القيمة الإجمالية',
    average_cart_value: 'متوسط قيمة السلة',
    conversion_rate: 'معدل التحويل',

    // Filters
    search: 'بحث',
    filter_by_time: 'تصفية حسب الوقت',
    sort_by: 'ترتيب حسب',
    total: 'الإجمالي',
    updated_at: 'تاريخ التحديث',

    // Pagination
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    results: 'نتيجة',
    previous: 'السابق',
    next: 'التالي',

    // Cart Details
    customer_name: 'اسم العميل',
    customer_email: 'بريد العميل',
    customer_phone: 'هاتف العميل',
    cart_total: 'إجمالي السلة',
    cart_items_count: 'عدد عناصر السلة',
    age_in_minutes: 'العمر بالدقائق',
    created_at: 'تاريخ الإنشاء',
    checkout_url: 'رابط الدفع',

    // Notifications
    local_notifications: 'الإشعارات المحلية',
    status_sent: 'تم الإرسال',
    status_pending: 'قيد الانتظار',
    converted: 'تم التحويل',
    reminder_count: 'عدد التذكيرات',
    sent_at: 'تاريخ الإرسال',

    // Additional keys for SallaAppPage
    your_integrations: 'تكاملاتك',
    connected_at: 'تاريخ الاتصال',
    manage_abandoned_carts: 'إدارة واسترداد السلات المتروكة',
    manage_settings: 'تكوين إعدادات التطبيق والتفضيلات',
    integration_stats: 'إحصائيات التكامل',
    //  active: 'نشط',
    enter_store_name: 'أدخل اسم المتجر',
    enter_store_url: 'أدخل رابط المتجر',
    enter_store_id: 'أدخل معرف المتجر',

    // Additional keys for AbandonedCartsPage
    no_salla_integrations_found: 'لم يتم العثور على تكاملات سلة',
    need_to_set_up_salla_integration_first: 'تحتاج إلى إعداد تكامل سلة أولاً لعرض السلات المتروكة.',
    loading_abandoned_carts_data: 'جاري تحميل بيانات السلات المتروكة...',
    updating_search_results: 'جاري تحديث نتائج البحث...',
    updating_results: 'جاري تحديث النتائج...',
    abandoned_carts: 'السلات المتروكة',

    // Abandoned Carts Management
    abandoned_carts_management: 'إدارة السلات المتروكة',
    track_and_recover_abandoned_carts: 'تتبع واسترداد السلات المتروكة',
    syncing: 'جاري المزامنة...',
    sync_from_salla: 'مزامنة من سلة',
    select_store_integration: 'اختر تكامل المتجر',
    // Statistics
    total_abandoned: 'إجمالي المتروكة',
    recovery_rate: 'معدل الاسترداد',
    pending_recovery: 'في انتظار الاسترداد',

    // Filters and Search
    showing_carts_from: 'عرض السلات من:',
    all_time: 'كل الوقت',
    last_7_hours: 'آخر 7 ساعات',
    last_week: 'الأسبوع الماضي',
    last_month: 'الشهر الماضي أو أكثر',
    search_customers_categories: 'البحث عن العملاء، الفئات...',
    sort_by_abandoned_date: 'ترتيب حسب تاريخ التخلي',
    sort_by_last_updated: 'ترتيب حسب آخر تحديث',
    sort_by_total_value: 'ترتيب حسب القيمة الإجمالية',
    sort_by_customer_name: 'ترتيب حسب اسم العميل',

    // Cart List
    no_abandoned_carts_found: 'لم يتم العثور على سلات متروكة',
    try_adjusting_search_terms: 'حاول تعديل مصطلحات البحث',
    all_carts_recovered_or_processing: 'تم استرداد جميع السلات أو قيد المعالجة',

    // Cart Item
    cart_id: 'معرف السلة',
    //  items: 'عناصر',
    attempts: 'المحاولات',
    //  store: 'المتجر',
    cart_value: 'قيمة السلة',
    contacted: 'تم الاتصال',
    contact: 'اتصال',
    recovered: 'تم الاسترداد',
    mark_recovered: 'تحديد كمسترد',

    // Time-related translations for getTimeAgo
    less_than_1_hour: 'أقل من ساعة واحدة',
    hours_ago: 'منذ :count ساعة',
    days_ago: 'منذ :count يوم',
    weeks_ago: 'منذ :count أسبوع',

    // Settings Header
    settings_header: {
      title: 'إدارة الإعدادات',
      description: 'تكوين وإدارة إعدادات تطبيق سلة',
      saving: 'جاري الحفظ...',
      saveAllChanges: 'حفظ جميع التغييرات',
      backToDashboard: 'العودة للوحة التحكم',
    },

    // Additional Settings Keys
    modified: 'معدل',
    settings_for_store: 'إعدادات :store',
    store_integration_not_found: 'لم يتم العثور على تكامل المتجر المطلوب.',
    loading_settings: 'جاري تحميل الإعدادات...',
    no_settings_for_category: 'لم يتم العثور على إعدادات لفئة {category}.',
    not_set: 'غير محدد',

    // Toast Messages
    success: 'نجح',
    error: 'خطأ',
    info: 'معلومات',
    warning: 'تحذير',
    campaign_created_successfully: 'تم إنشاء الحملة بنجاح',
    campaign_updated_successfully: 'تم تحديث الحملة بنجاح',
    campaign_deleted_successfully: 'تم حذف الحملة بنجاح',
    campaign_started_successfully: 'تم بدء الحملة بنجاح',
    campaign_paused_successfully: 'تم إيقاف الحملة مؤقتاً بنجاح',
    campaign_completed_successfully: 'تم إكمال الحملة بنجاح',
    campaign_retry_successfully: 'تم بدء إعادة المحاولة للحملة بنجاح',
    failed_to_create_campaign: 'فشل في إنشاء الحملة',
    failed_to_update_campaign: 'فشل في تحديث الحملة',
    failed_to_delete_campaign: 'فشل في حذف الحملة',
    failed_to_start_campaign: 'فشل في بدء الحملة',
    failed_to_pause_campaign: 'فشل في إيقاف الحملة مؤقتاً',
    failed_to_complete_campaign: 'فشل في إكمال الحملة',
    failed_to_retry_campaign: 'فشل في إعادة المحاولة للحملة',
    settings_saved_successfully: 'تم حفظ الإعدادات بنجاح',
    failed_to_save_settings: 'فشل في حفظ الإعدادات',
    integration_added_successfully: 'تم إضافة التكامل بنجاح',
    failed_to_add_integration: 'فشل في إضافة التكامل',
    abandoned_carts_synced_successfully: 'تم مزامنة السلات المتروكة بنجاح من سلة',
    failed_to_sync_abandoned_carts: 'فشل في مزامنة السلات المتروكة من سلة',
    cart_status_updated_successfully: 'تم تحديث حالة السلة بنجاح',
    failed_to_update_cart_status: 'فشل في تحديث حالة السلة',
    no_integration_selected: 'لم يتم اختيار تكامل',
    invalid_action: 'إجراء غير صحيح',

    // Setting Title Keys
    setting_titles: {
      instance_id: 'معرّف الجهاز (Instance ID)',
      access_token: 'رمز الوصول (Access Token)',

      new_order_enabled: 'تفعيل/تعطيل - طلب جديد',
      new_order_message: 'محتوى الرسالة - طلب جديد',
      new_order_image: 'صورة الإشعار (اختياري) - طلب جديد',

      payment_pending_enabled: 'تفعيل/تعطيل - بإنتظار الدفع',
      payment_pending_message: 'محتوى الرسالة - بإنتظار الدفع',
      payment_pending_image: 'صورة الإشعار (اختياري) - بإنتظار الدفع',

      payment_method_cod_enabled: 'تفعيل/تعطيل - الدفع عند الاستلام',
      payment_method_cod_message: 'محتوى الرسالة - الدفع عند الاستلام',
      payment_method_cod_image: 'صورة الإشعار (اختياري) - الدفع عند الاستلام',

      under_review_enabled: 'تفعيل/تعطيل - بإنتظار المراجعة',
      under_review_message: 'محتوى الرسالة - بإنتظار المراجعة',
      under_review_image: 'صورة الإشعار (اختياري) - بإنتظار المراجعة',

      in_progress_enabled: 'تفعيل/تعطيل - قيد التنفيذ',
      in_progress_message: 'محتوى الرسالة - قيد التنفيذ',
      in_progress_image: 'صورة الإشعار (اختياري) - قيد التنفيذ',

      delivering_enabled: 'تفعيل/تعطيل - جاري التوصيل',
      delivering_message: 'محتوى الرسالة - جاري التوصيل',
      delivering_image: 'صورة الإشعار (اختياري) - جاري التوصيل',

      delivered_enabled: 'تفعيل/تعطيل - تم التوصيل',
      delivered_message: 'محتوى الرسالة - تم التوصيل',
      delivered_image: 'صورة الإشعار (اختياري) - تم التوصيل',

      shipped_enabled: 'تفعيل/تعطيل - تم الشحن',
      shipped_message: 'محتوى الرسالة - تم الشحن',
      shipped_image: 'صورة الإشعار (اختياري) - تم الشحن',

      completed_enabled: 'تفعيل/تعطيل - تم التنفيذ',
      completed_message: 'محتوى الرسالة - تم التنفيذ',
      completed_image: 'صورة الإشعار (اختياري) - تم التنفيذ',

      canceled_enabled: 'تفعيل/تعطيل - ملغي',
      canceled_message: 'محتوى الرسالة - ملغي',
      canceled_image: 'صورة الإشعار (اختياري) - ملغي',

      restoring_enabled: 'تفعيل/تعطيل - قيد الاسترجاع',
      restoring_message: 'محتوى الرسالة - قيد الاسترجاع',
      restoring_image: 'صورة الإشعار (اختياري) - قيد الاسترجاع',

      restored_enabled: 'تفعيل/تعطيل - مسترجع',
      restored_message: 'محتوى الرسالة - مسترجع',
      restored_image: 'صورة الإشعار (اختياري) - مسترجع',

      request_quote_enabled: 'تفعيل/تعطيل - طلب عرض سعر',
      request_quote_message: 'محتوى الرسالة - طلب عرض سعر',
      request_quote_image: 'صورة الإشعار (اختياري) - طلب عرض سعر',

      review_enabled: 'تفعيل/تعطيل - طلب التقييم',
      review_trigger_status: 'الحالة التي يتم عندها إرسال إشعار التقييم',
      review_delay_unit: 'نوع وحدة الزمن',
      review_delay_value: 'مدة الانتظار قبل إرسال التقييم',
      review_message: 'محتوى رسالة طلب التقييم',
      review_image: 'صورة مرفقة (اختياري)',
      review_reminder_enabled: 'تفعيل/تعطيل التذكير بالتقييم',
      review_reminder_times: 'عدد مرات التذكير',
      review_reminder_interval_unit: 'نوع الفاصل الزمني',
      review_reminder_interval_value: 'قيمة الفاصل الزمني بين التذكيرات',
      review_reminder_message: 'رسالة التذكير',

      send_activation_code_enabled: 'تفعيل/تعطيل - إرسال رمز التفعيل',
      customer_otp_message: 'محتوى الرسالة - رمز التفعيل',

      welcome_customer_enabled: 'تفعيل/تعطيل - إشعار الترحيب',
      welcome_customer_message: 'محتوى الرسالة - إشعار الترحيب',
      welcome_customer_image: 'صورة الإشعار (اختياري) - إشعار الترحيب',

      abandoned_cart_enabled: 'تفعيل/تعطيل إشعار السلات المتروكة',
      abandoned_cart_interval_unit: 'نوع الفاصل الزمني',
      abandoned_cart_interval_value: 'قيمة الفاصل الزمني بين التذكيرات',
      abandoned_cart_message: 'محتوى رسالة السلات المتروكة',
      abandoned_cart_image: 'صورة الإشعار (اختياري) - السلات المتروكة',

      post_rating_feedback_excellent_enabled: 'تفعيل/تعطيل - رسالة بعد التقييم (ممتاز)',
      post_rating_feedback_excellent_message: 'محتوى الرسالة - تقييم ممتاز',
      post_rating_feedback_excellent_image: 'صورة مرفقة (اختياري) - تقييم ممتاز',
      post_rating_feedback_excellent_coupon_type: 'نوع الخصم (تقييم ممتاز)',
      post_rating_feedback_excellent_coupon_value: 'قيمة الخصم (تقييم ممتاز)',
      post_rating_feedback_excellent_coupon_max_discount: 'الحد الأقصى للخصم (تقييم ممتاز)',
      post_rating_feedback_excellent_coupon_free_shipping: 'شحن مجاني (تقييم ممتاز)',
      post_rating_feedback_excellent_coupon_expires_in_days: 'مدة صلاحية الكوبون (تقييم ممتاز)',

      post_rating_feedback_very_good_enabled: 'تفعيل/تعطيل - رسالة بعد تقييم جيد جدًا (4 نجوم)',
      post_rating_feedback_very_good_message: 'محتوى الرسالة - تقييم جيد جدًا',
      post_rating_feedback_very_good_image: 'صورة مرفقة - تقييم جيد جدًا',
      post_rating_feedback_very_good_coupon_type: 'نوع الخصم (تقييم جيد جدًا)',
      post_rating_feedback_very_good_coupon_value: 'قيمة الخصم (تقييم جيد جدًا)',
      post_rating_feedback_very_good_coupon_max_discount: 'الحد الأقصى للخصم (تقييم جيد جدًا)',
      post_rating_feedback_very_good_coupon_free_shipping: 'شحن مجاني (تقييم جيد جدًا)',
      post_rating_feedback_very_good_coupon_expires_in_days: 'مدة صلاحية الكوبون (تقييم جيد جدًا)',

      post_rating_feedback_good_enabled: 'تفعيل/تعطيل - رسالة بعد تقييم جيد (3 نجوم)',
      post_rating_feedback_good_message: 'محتوى الرسالة - تقييم جيد',
      post_rating_feedback_good_image: 'صورة مرفقة - تقييم جيد',
      // ملاحظة: في HTML عنوان حقل نوع الخصم ظهر كنص "قيمة الخصم (تقييم جيد)" (واضح أنه سهو في الواجهة)
      post_rating_feedback_good_coupon_type: 'قيمة الخصم (تقييم جيد)',
      post_rating_feedback_good_coupon_value: 'قيمة الخصم (تقييم جيد)',
      post_rating_feedback_good_coupon_max_discount: 'الحد الأقصى للخصم (تقييم جيد)',
      post_rating_feedback_good_coupon_free_shipping: 'شحن مجاني (تقييم جيد)',
      post_rating_feedback_good_coupon_expires_in_days: 'مدة صلاحية الكوبون (تقييم جيد)',

      post_rating_feedback_bad_enabled: 'تفعيل/تعطيل - رسالة بعد تقييم سيئ (نجمتين أو أقل)',
      post_rating_feedback_bad_message: 'محتوى الرسالة - تقييم سيئ',
      post_rating_feedback_bad_image: 'صورة مرفقة - تقييم سيئ',
      post_rating_feedback_bad_coupon_type: 'نوع الخصم (تقييم سيئ)',
      post_rating_feedback_bad_coupon_value: 'قيمة الخصم (تقييم سيئ)',
      post_rating_feedback_bad_coupon_max_discount: 'الحد الأقصى للخصم (تقييم سيئ)',
      post_rating_feedback_bad_coupon_free_shipping: 'شحن مجاني (تقييم سيئ)',
      post_rating_feedback_bad_coupon_expires_in_days: 'مدة صلاحية الكوبون (تقييم سيئ)',

      admin_new_order_enabled: 'تفعيل/تعطيل - إشعار طلب جديد',
      admin_new_order_phones: 'أرقام الهواتف المستلمة للإشعار',
      admin_new_order_message: 'محتوى رسالة إشعار الطلب الجديد',

      admin_low_stock_enabled: 'تفعيل/تعطيل - تنبيه انخفاض المخزون',
      admin_low_stock_phones: 'أرقام الهواتف المستلمة للتنبيه',
      admin_low_stock_message: 'محتوى رسالة تنبيه انخفاض المخزون',

      show_whatsapp_widget: 'تفعيل/تعطيل - ايقون الواتساب',
      whatsapp_widget_logo: 'شعار المتجر',
      whatsapp_widget_phone: 'رقم الجوال (مع كود الدولة)',
      whatsapp_widget_default_message: 'الرسالة الافتراضية على واتساب',
      whatsapp_widget_show_status: 'عرض حالة الرقم',
      whatsapp_widget_status_text: 'حالة الرقم',
      whatsapp_widget_qrcode_enabled: 'تفعيل / تعطيل QR',
      whatsapp_widget_popup_text: 'رسالة الترحيب',
      whatsapp_widget_button_text: 'نص زر واتساب',
      whatsapp_widget_position: 'موضع الودجت على الشاشة',
      whatsapp_widget_margin: 'الهامش من حواف الصفحة (بالبكسل)',
      whatsapp_widget_button_size: 'حجم زر واتساب',
      whatsapp_widget_primary_color: 'اللون الأساسي',
      whatsapp_widget_hover_color: 'اللون عند التمرير على الزر',
    },

    // Helper Text Keys
    helper: {
      instance_id: 'معرف فريد لهذا التكامل',
      access_token: 'رمز المصادقة للوصول إلى API سلة',

      new_order_enabled: 'تفعيل الإشعارات للطلبات الجديدة',
      new_order_message: 'قالب الرسالة لإشعارات الطلبات الجديدة',
      new_order_image: 'الصورة لتضمينها مع إشعارات الطلبات الجديدة',

      payment_pending_enabled: 'تفعيل الإشعارات للمدفوعات المعلقة',
      payment_pending_message: 'قالب الرسالة لإشعارات المدفوعات المعلقة',
      payment_pending_image: 'الصورة لتضمينها مع إشعارات المدفوعات المعلقة',

      payment_method_cod_enabled: 'تفعيل الإشعارات لطلبات الدفع عند الاستلام',
      payment_method_cod_message: 'قالب الرسالة لإشعارات الدفع عند الاستلام',
      payment_method_cod_image: 'الصورة لتضمينها مع إشعارات الدفع عند الاستلام',

      under_review_enabled: 'تفعيل الإشعارات للطلبات قيد المراجعة',
      under_review_message: 'قالب الرسالة لإشعارات المراجعة',
      under_review_image: 'الصورة لتضمينها مع إشعارات المراجعة',

      in_progress_enabled: 'تفعيل الإشعارات للطلبات قيد التنفيذ',
      in_progress_message: 'قالب الرسالة لإشعارات التنفيذ',
      in_progress_image: 'الصورة لتضمينها مع إشعارات التنفيذ',

      delivering_enabled: 'تفعيل الإشعارات لتوصيل الطلبات',
      delivering_message: 'قالب الرسالة لإشعارات التوصيل',
      delivering_image: 'الصورة لتضمينها مع إشعارات التوصيل',

      delivered_enabled: 'تفعيل الإشعارات للطلبات الموصلة',
      delivered_message: 'قالب الرسالة لإشعارات التوصيل المكتمل',
      delivered_image: 'الصورة لتضمينها مع إشعارات التوصيل المكتمل',

      shipped_enabled: 'تفعيل الإشعارات للطلبات المشحونة',
      shipped_message: 'قالب الرسالة لإشعارات الشحن',
      shipped_image: 'الصورة لتضمينها مع إشعارات الشحن',

      completed_enabled: 'تفعيل الإشعارات للطلبات المكتملة',
      completed_message: 'قالب الرسالة لإشعارات الإكمال',
      completed_image: 'الصورة لتضمينها مع إشعارات الإكمال',

      canceled_enabled: 'تفعيل الإشعارات للطلبات الملغاة',
      canceled_message: 'قالب الرسالة لإشعارات الإلغاء',
      canceled_image: 'الصورة لتضمينها مع إشعارات الإلغاء',

      restoring_enabled: 'تفعيل الإشعارات لاستعادة الطلبات',
      restoring_message: 'قالب الرسالة لإشعارات الاستعادة',
      restoring_image: 'الصورة لتضمينها مع إشعارات الاستعادة',

      restored_enabled: 'تفعيل الإشعارات للطلبات المستعادة',
      restored_message: 'قالب الرسالة لإشعارات الاستعادة المكتملة',
      restored_image: 'الصورة لتضمينها مع إشعارات الاستعادة المكتملة',

      request_quote_enabled: 'تفعيل الإشعارات لطلبات عرض السعر',
      request_quote_message: 'قالب الرسالة لإشعارات طلب عرض السعر',
      request_quote_image: 'الصورة لتضمينها مع إشعارات طلب عرض السعر',

      review_enabled: 'تفعيل طلبات التقييم التلقائية للطلبات',
      review_trigger_status: 'حالة الطلب التي تطلق طلب التقييم',
      review_delay_unit: 'وحدة الوقت لتأخير التقييم',
      review_delay_value: 'عدد وحدات الوقت للانتظار قبل إرسال طلب التقييم',
      review_message: 'قالب الرسالة لطلبات التقييم',
      review_image: 'الصورة لتضمينها مع طلبات التقييم',

      review_reminder_enabled: 'تفعيل إشعارات التذكير للتقييمات',
      review_reminder_times: 'عدد إشعارات التذكير المرسلة',
      review_reminder_interval_unit: 'وحدة الوقت لفترات التذكير',
      review_reminder_interval_value: 'عدد وحدات الوقت بين التذكيرات',
      review_reminder_message: 'قالب الرسالة لتذكيرات التقييم',

      send_activation_code_enabled: 'تفعيل إرسال رموز التفعيل للعملاء الجدد',
      customer_otp_message: 'قالب الرسالة للتحقق من رمز العميل',

      welcome_customer_enabled: 'تفعيل رسائل الترحيب للعملاء الجدد',
      welcome_customer_message: 'قالب الرسالة لرسائل الترحيب بالعملاء',
      welcome_customer_image: 'الصورة لتضمينها مع رسائل الترحيب',

      abandoned_cart_enabled: 'تفعيل إشعارات استرداد السلات المتروكة',
      abandoned_cart_interval_unit: 'وحدة الوقت لفترات إشعارات السلات المتروكة',
      abandoned_cart_interval_value: 'عدد وحدات الوقت للانتظار قبل إرسال إشعارات السلات المتروكة',
      abandoned_cart_message: 'قالب الرسالة لاسترداد السلات المتروكة',
      abandoned_cart_image: 'الصورة لتضمينها مع إشعارات السلات المتروكة',

      post_rating_feedback_excellent_enabled: 'تفعيل التغذية الراجعة للتقييمات الممتازة',
      post_rating_feedback_excellent_message: 'قالب الرسالة للتغذية الراجعة للتقييمات الممتازة',
      post_rating_feedback_excellent_image: 'الصورة لتضمينها مع التغذية الراجعة للتقييمات الممتازة',
      post_rating_feedback_excellent_coupon_type: 'نوع الكوبون للتقييمات الممتازة',
      post_rating_feedback_excellent_coupon_value: 'قيمة الكوبون للتقييمات الممتازة',
      post_rating_feedback_excellent_coupon_max_discount:
        'أقصى مبلغ خصم لكوبونات التقييمات الممتازة',
      post_rating_feedback_excellent_coupon_free_shipping:
        'تفعيل الشحن المجاني لكوبونات التقييمات الممتازة',
      post_rating_feedback_excellent_coupon_expires_in_days:
        'عدد الأيام حتى انتهاء صلاحية كوبون التقييم الممتاز',

      post_rating_feedback_very_good_enabled: 'تفعيل التغذية الراجعة للتقييمات الجيدة جداً',
      post_rating_feedback_very_good_message: 'قالب الرسالة للتغذية الراجعة للتقييمات الجيدة جداً',
      post_rating_feedback_very_good_image:
        'الصورة لتضمينها مع التغذية الراجعة للتقييمات الجيدة جداً',
      post_rating_feedback_very_good_coupon_type: 'نوع الكوبون للتقييمات الجيدة جداً',
      post_rating_feedback_very_good_coupon_value: 'قيمة الكوبون للتقييمات الجيدة جداً',
      post_rating_feedback_very_good_coupon_max_discount:
        'أقصى مبلغ خصم لكوبونات التقييمات الجيدة جداً',
      post_rating_feedback_very_good_coupon_free_shipping:
        'تفعيل الشحن المجاني لكوبونات التقييمات الجيدة جداً',
      post_rating_feedback_very_good_coupon_expires_in_days:
        'عدد الأيام حتى انتهاء صلاحية كوبون التقييم الجيد جداً',

      post_rating_feedback_good_enabled: 'تفعيل التغذية الراجعة للتقييمات الجيدة',
      post_rating_feedback_good_message: 'قالب الرسالة للتغذية الراجعة للتقييمات الجيدة',
      post_rating_feedback_good_image: 'الصورة لتضمينها مع التغذية الراجعة للتقييمات الجيدة',
      post_rating_feedback_good_coupon_type: 'نوع الكوبون للتقييمات الجيدة',
      post_rating_feedback_good_coupon_value: 'قيمة الكوبون للتقييمات الجيدة',
      post_rating_feedback_good_coupon_max_discount: 'أقصى مبلغ خصم لكوبونات التقييمات الجيدة',
      post_rating_feedback_good_coupon_free_shipping:
        'تفعيل الشحن المجاني لكوبونات التقييمات الجيدة',
      post_rating_feedback_good_coupon_expires_in_days:
        'عدد الأيام حتى انتهاء صلاحية كوبون التقييم الجيد',

      post_rating_feedback_bad_enabled: 'تفعيل التغذية الراجعة للتقييمات السيئة',
      post_rating_feedback_bad_message: 'قالب الرسالة للتغذية الراجعة للتقييمات السيئة',
      post_rating_feedback_bad_image: 'الصورة لتضمينها مع التغذية الراجعة للتقييمات السيئة',
      post_rating_feedback_bad_coupon_type: 'نوع الكوبون للتقييمات السيئة',
      post_rating_feedback_bad_coupon_value: 'قيمة الكوبون للتقييمات السيئة',
      post_rating_feedback_bad_coupon_max_discount: 'أقصى مبلغ خصم لكوبونات التقييمات السيئة',
      post_rating_feedback_bad_coupon_free_shipping:
        'تفعيل الشحن المجاني لكوبونات التقييمات السيئة',
      post_rating_feedback_bad_coupon_expires_in_days:
        'عدد الأيام حتى انتهاء صلاحية كوبون التقييم السيء',

      admin_new_order_enabled: 'تفعيل إشعارات الإدارة للطلبات الجديدة',
      admin_new_order_phones: 'أرقام الهواتف لاستقبال إشعارات الطلبات الجديدة (مفصولة بفواصل)',
      admin_new_order_message: 'قالب الرسالة لإشعارات الإدارة للطلبات الجديدة',

      admin_low_stock_enabled: 'تفعيل إشعارات الإدارة للمخزون المنخفض',
      admin_low_stock_phones: 'أرقام الهواتف لاستقبال إشعارات المخزون المنخفض (مفصولة بفواصل)',
      admin_low_stock_message: 'قالب الرسالة لإشعارات الإدارة للمخزون المنخفض',

      show_whatsapp_widget: 'إظهار ويدجت الواتساب في متجرك',
      whatsapp_widget_logo: 'صورة الشعار لويدجت الواتساب',
      whatsapp_widget_phone: 'رقم الهاتف لويدجت الواتساب',
      whatsapp_widget_default_message: 'الرسالة الافتراضية عند النقر على ويدجت الواتساب',
      whatsapp_widget_show_status: 'إظهار حالة الاتصال/عدم الاتصال في ويدجت الواتساب',
      whatsapp_widget_status_text: 'نص مخصص لإظهاره في منطقة الحالة',
      whatsapp_widget_qrcode_enabled: 'تفعيل إنشاء رمز QR لويدجت الواتساب',
      whatsapp_widget_popup_text: 'النص لإظهاره في النافذة المنبثقة',
      whatsapp_widget_button_text: 'النص لإظهاره على زر الويدجت',
      whatsapp_widget_position: 'موضع ويدجت الواتساب في الصفحة',
      whatsapp_widget_margin: 'المسافة من حافة الصفحة (بالبكسل)',
      whatsapp_widget_button_size: 'حجم زر الويدجت (بالبكسل)',
      whatsapp_widget_primary_color: 'اللون الأساسي لويدجت الواتساب',
      whatsapp_widget_hover_color: 'اللون عند التمرير فوق ويدجت الواتساب',
    },
  },
  groups: 'المجموعات',
  chats: 'المحادثات',
  refresh: 'اعادة تشغيل',
  view: 'عرض',
  copy: 'نسخ',
  connected: 'متصل',
  close_connection: 'قطع الاتصال',
  close: 'مغلق',
  connecting: 'جاري الاتصال',
  disconnect: 'إيقاف التشغيل',
  text_open_whatsapp: 'افتح تطبيق WhatsApp على هاتفك.',
  text_open_whatsapp_menu: 'اضغط على القائمة أو الإعدادات واختر الأجهزة المرتبطة.',
  text_open_whatsapp_phone: 'وجّه هاتفك إلى هذه الشاشة لالتقاط الباركود.',
  text_after_auth_whatsapp: 'سيكون إرسال الرسائل متاحًا بعد المصادقة مباشرةً.',
  text_title_qrcode_send: 'لإرسال واستقبال الرسائل، يجب عليك تفويض الجهاز:',
  successUpdate: 'تم الحفظ بنجاح',
  created_at: 'تاريخ الانشاء',
  userGroup: 'مجموعة الادارة',
  usersGroups: 'مجموعات الادارديين',
  permissions: 'الصلاحيات',
  administrator: 'الادارة والصلاحيات',
  users: 'الاداريين',
  user: 'الاداري',
  pictureUrl: 'الصورة',
  group_id: 'رقم المجموعة',
  group_owner_number: 'رقم رقم المالك',
  group_name: 'اسم المجموعة',
  contacts_groups: 'قوائم جهات الاتصال',
  whatsapp_contact: 'قائمة جهة الاتصال',
  group_owner: 'المالك',
  sync_groups: 'مزامنة المجموعات',
  group_members_count: 'عدد الاعضاء',
  sync_contacts_group: 'مزامنة ارقام المجموعة',
  no_contacts: 'لا يوجد جهات اتصال',
  for_contacts_groups: '  أعضاء مجموعة :group_name',
  loading_contacts_groups: 'جاري تحميل أعضاء المجموعة ... ',
  sync: 'مزامنة',
  chatBots: 'شات بوت',
  chatBot: 'شات بوت',
  textMessage: 'رسالة نصية',
  textMessageDescription: 'إرسال رسالة نصية إلى المستخدم.',
  imageMessage: 'رسالة صورة',
  imageMessageDescription: 'إرسال صورة إلى المستخدم.',
  videoMessage: 'رسالة فيديو',
  videoMessageDescription: 'إرسال فيديو إلى المستخدم.',
  locationMessage: 'مشاركة الموقع',
  locationMessageDescription: 'إرسال الموقع الجغرافي للمستخدم.',
  apiRequest: 'طلب API',
  apiRequestDescription: 'إجراء طلب إلى نقطة نهاية API.',
  documentMessage: 'رسالة مستند',
  documentMessageDescription: 'إرسال مستند مثل PDF أو ملفات نصية.',
  contactMessage: 'مشاركة جهه اتصال',
  stickerMessage: 'ارسال ملصق',
  contactMessageDescription: 'مشاركة جهات اتصال',
  stickerMessageDescription: 'مشاركة  ملصق',
  listGroups: 'قائمة الخيارات',
  listGroupsDescription: 'عرض قائمة من الخيارات للمستخدم.',
  gptNode: 'ذكاء اصطناعي',
  gptNodeDescription: 'إجراء محادثة باستخدام الذكاء الاصطناعي.',
  audioMessage: 'رسالة صوتية',
  audioMessageDescription: 'إرسال تسجيل صوتي.',
  success_upload_excel: ' تم استلام الملف وجارٍ استيراد البيانات، سيتم إشعارك عند الانتهاء.',
  on_whatsapp: 'متوفر على واتساب',
  not_on_whatsapp: 'غير مسجل في واتساب',
  contacts_import_logs: 'سجل الاستيراد',
  in_progress: ' قيد التنفيذ',
  done: 'مكتمل',
  failed: 'فشل التنفيذ',
  total_rows: 'إجمالي جهات الاتصال',
  successful_imports: 'تم الاستيراد بنجاح',
  failed_imports: 'فشل استيرادها',
  status: 'الحالة',
  download_excel_template: 'تحميل نموذج ملف Excel',
  download_excel_template_description:
    'قم بتحميل نموذج ملف Excel واملأه بالبيانات المطلوبة قبل استيراده.',
  optional_fields: 'الحقول الاختيارية:',
  image: 'الصورة',
  gender: 'الجنس',
  optional: 'اختياري',
  import: 'استيراد',
  blacklist: 'القائمة السوداء',
  phone_numbers: 'ارقام الهاتف',
  unsubscribe_settings: 'إعدادات إلغاء الاشتراك',
  unsubscribe_settings_description: 'قم بتمكين العملاء من إلغاء الاشتراك في استقبال الرسائل منك',
  unsubscribe_text: 'نص إلغاء الاشتراك',
  unsubscribe_text_description: 'اكتب النص الذي سيظهر في نهاية كل رسالة',
  unsubscribe_keywords: 'كلمات مفتاحية لإلغاء الاشتراك',
  unsubscribe_keywords_description: 'حدد الكلمات التي عند إرسالها يتم إلغاء الاشتراك تلقائيًا',
  unsubscribe_confirmation_message: 'رسالة تأكيد إلغاء الاشتراك',
  unsubscribe_confirmation_description: 'اكتب الرسالة التي سيتم إرسالها لتأكيد الإلغاء',
  successUpdateSettings: 'تم حفظ الاعدادات بنجاح',
  copied: 'تم النسخ',
  autoResponder: 'الردود الترحيبية',
  welcomeMessages: 'الردود التلقائية',
  welcomeMessageDescription: 'ارسال رسائل اليه لعملائك عندما تكون غير متاح او مشغول',
  loading_auto_responder_data: 'جاري تحميل الردود التلقائية',
  templates: 'القوالب',
  text_media_templates: 'نص وميديا',
  list_templates: 'قوائم',
  poll_templates: 'تصويت',
  button_templates: 'أزرار تفاعلية',
  buttons: 'الأزرار',
  button: 'زر',
  add_button: 'إضافة زر',
  remove_button: 'إزالة زر',
  button_text: 'نص الزر',
  button_action: 'إجراء الزر',
  button_type: 'نوع الزر',
  max_buttons_reached: 'تم الوصول للحد الأقصى من الأزرار',
  reply_text_placeholder: 'أدخل نص الرد',
  url_placeholder: 'أدخل الرابط (مثال: https://example.com)',
  phone_number_placeholder: 'أدخل رقم الهاتف (مثال: +1234567890)',
  footer_text_placeholder: 'أدخل نص التذييل',
  // section_title: 'عنوان القسم',
  // add_section: 'إضافة قسم',
  // remove_section: 'حذف القسم',
  // add_row: 'إضافة صف',
  // remove_row: 'حذف الصف',
  // row_title: 'عنوان الصف',
  // row_description: 'وصف الصف',
  campaigns: 'الحملات الاعلانية',
  view_campaigns: 'عرض الحملات الاعلانية',
  create_campaigns: 'اضافة حملة اعلانية',
  nameCampaign: 'اسم الحملة',
  instances: 'حسابات الواتس اب',
  start_at: 'تاريخ البدء',
  generalSettings: 'الاعدادات العامة',
  webhookSettings: 'اعدادات webhook',
  campaigns_and_schedule: 'الحملات الاعلانية والجدولة',
  schedules: 'الجدولة الدورية',
  recipients_count: 'عدد المستقبلين',
  text_qr_connecting: 'جاري محاولة الاتصال...',
  text_qr_connecting_info: 'يرجى الانتظار حتى تكتمل عملية الاتصال.',
  text_login_by_code: 'تسجيل الدخول باستخدام رمز الاقتران',
  text_login_by_code_info:
    'يمكنك استخدام هذه الطريقة كبديل إذا واجهت صعوبة في تسجيل الدخول عبر رمز QR.',
  text_enter_phone_number: 'الرجاء إدخال رقم الجوال  .',
  text_send_code: 'ارسال الرمز',
  text_back: 'رجوع',
  text_close: 'إغلاق',
  text_enter_received_code: 'أدخل هذا الرمز في حساب WhatsApp الخاص بك لإكمال عملية تسجيل الدخول.',
  choose_file: 'اختر ملف',
  no_choose_file: 'لم يتم اختيار ملف',
  confirmBlacklistAdd: 'هل أنت متأكد من إضافة :name إلى القائمة السوداء؟',
  confirmBlacklistHeading: 'تأكيد الإضافة إلى القائمة السوداء',
  blacklistAddSuccess: 'تمت الإضافة إلى القائمة السوداء بنجاح',
  addToBlacklist: 'إضافة إلى القائمة السوداء',
  shortenerUrlSettings: 'اعدادات اختصار الروابط',
  old_password: 'كلمة المرور القديمة',
  // new_password: 'كلمة المرور الجديدة',
  new_password_confirmation: 'تأكيد كلمة المرور الجديدة',
  successUpdateProfile: 'تم تحديث ملفك الشخصي',
  successChangePassword: 'تم تغيير كلمة مرورك',
  no_active_subscription: 'لا يوجد اشتراك نشط حاليًا.',
  status_active: 'نشط',
  status_trial: 'تجريبي',
  status_ended: 'منتهي',
  subscription_title: ' المميزات',
  billing_cycle: 'دورة الفوترة',
  trial_period: 'فترة التجربة',
  start_date: 'تاريخ البدء',
  end_date: 'تاريخ الانتهاء',
  trial_end_date: 'نهاية التجربة',
  enabled: 'مفعلة ',
  not_enabled: 'غير مفعلة ',
  upgrade_plan: 'ترقية الباقة',
  start_node: 'البداية',
  contains_keywords: ' تحتوي على ',
  must_match_keywords: 'يجب ان تساوي',
  all_keywords: 'الكل',
  resend_after_delay: 'إعادة الرد بعد وقت معين',
  resend_after_delay_description:
    'يمكنك من هنا ضبط ميزة إعادة الرد بعد وقت معين، حيث يتم إرسال الرد التلقائي مرة أخرى إلى العميل بعد مرور فترة محددة (بالثواني)، مما يساعد في استمرارية التواصل دون إرسال ردود متكررة بشكل مزعج.',
  duration: 'المدة:',
  important_note: 'ملاحظة هامة',
  zero_delay_warning:
    'لم يتم تعيين فارق زمني، مما يعني أنه سيتم إرسال الرد التلقائي مع كل رسالة مرسلة من العميل، مما قد يؤدي إلى إرسال ردود متكررة بشكل مستمر.',
  second: 'ثانية',
  seconds: 'ثواني',
  minute: 'دقيقة',
  and: 'و',
  upload_image: 'ارفاق صورة',
  upload_image_url: 'رابط الصورة',
  upload_document: 'ارفاق ملف',
  upload_document_url: 'رابط الملف',
  upload_audio: 'ارفاق ملف صوتي',
  upload_audio_url: 'رابط الملف الصوتي',
  upload_sticker: 'ارفاق  ملصق',
  upload_sticker_url: 'رابط  الملصق',
  upload_video: 'ارفاق  فيديو',
  upload_video_url: 'رابط  الفيديو',
  title: 'العنوان',
  buttonText: 'نص الزر',
  footerText: 'نص التذييل',
  sectionTitle: 'عنوان القسم',
  addRow: 'إضافة قائمة',
  rowTitle: 'عنوان القائمة',
  rowDescription: 'وصف القائمة',
  rowRemove: 'حذف القائمة',
  addSection: 'إضافة قسم',
  removeSection: 'حذف القسم',
  addOption: 'إضافة خيار',
  saveSuccess: 'تم الحفظ بنجاح',
  autoResponderStatusDescription:
    'يمكنك من هنا تفعيل ميزة الردود التلقائية لإدارة محادثاتك بسهولة وتنظيم تفاعلك مع العملاء. 🚀',
  selectTargetType: 'تحديد الرد على',
  selectTargetTypeDescription: 'اختر الفئة التي سيتم إرسال الرد التلقائي لها:',
  targetUser: 'الأشخاص',
  targetGroup: 'المجموعات',
  targetAll: 'الكل',
  targetUserDescription: 'يتم إرسال الرد التلقائي إلى جميع الأفراد في المحادثات الخاصة.',
  targetGroupDescription: 'يتم إرسال الرد التلقائي فقط في المجموعات دون المحادثات الفردية.',
  targetAllDescription:
    'يتم إرسال الرد التلقائي إلى الجميع، سواء في المحادثات الخاصة أو في المجموعات.',
  messageDescription:
    'قم بكتابة محتوى الرد التلقائي الذي سيتم إرساله عند استلام رسالة من العميل وفقًا لإعداداتك.',
  attachments: 'المرفقات',
  attachmentsDescription:
    'قم بإرفاق صورة، فيديو، تسجيل صوتي، أو ملف (PDF, Excel) لجعل ردك أكثر وضوحًا وتفاعلية.',
  disabled: 'غير مفعل',
  messageStatus: 'حالة الرد',
  messageStatusDescription:
    'يمكنك من هنا تفعيل أو تعطيل هذا الرد التلقائي دون التأثير على باقي الردود.',
  timingTitle: 'توقيت إرسال الرد التلقائي',
  timingDescription: 'يمكنك تحديد الفترات الزمنية التي يتم فيها إرسال الرد التلقائي خلال اليوم.',
  fromTime: 'من الساعة',
  toTime: 'إلى الساعة',
  noTemplatesAvailable: 'لا يوجد قوالب متاحة.',
  selectTemplate: 'اختر قالب الرسالة',
  addNewAutoReply: 'إضافة رد تلقائي جديد',
  customMessage: 'رسالة مخصصة',
  templateMessage: 'قوالب الرسائل',
  loadingTemplates: 'جاري تحميل القوالب...',
  textAndMedia: 'نص ووسائط',
  list: 'قائمة',
  poll: 'تصويت',
  rejectCall: 'رفض المكالمات',
  rejectCallDesc: 'رفض المكالمات الواردة تلقائيًا.',
  msgCall: 'رسالة عند الاتصال',
  msgCallDesc: 'حدد رسالة مخصصة يتم إرسالها عند رفض المكالمات.',
  groupsIgnore: 'تجاهل المجموعات',
  groupsIgnoreDesc: 'تعطيل الإشعارات من محادثات المجموعات.',
  alwaysOnline: 'دائمًا متصل',
  alwaysOnlineDesc: 'إظهار حالتك كمتصل دائمًا.',
  readMessages: 'وضع علامة مقروء',
  readMessagesDesc: 'وضع علامة مقروء تلقائيًا على الرسائل الواردة.',
  readStatus: 'قراءة الحالة',
  readStatusDesc: 'قراءة تحديثات الحالة تلقائيًا.',
  shortenerEnabled: 'تفعيل الاختصار',
  shortenerEnabledDescription: 'تمكين أو تعطيل اختصار الروابط.',
  no_whatsapp_accounts: 'ليس لديك حسابات واتساب',
  regenerateToken: 'تغيير Api Token',
  successRegenerateToken: 'تم تغيير Api Token',
  messagesLog: 'سجل الرسائل',
  to: 'الى',
  sent: 'تم الارسال',
  source_type: 'مصدر الرسالة',
  message_type: 'نوع الرسالة',
  text: 'نص',
  location: 'الموقع',
  audio: 'الصوت',
  sticker: 'استيكر',
  contact: 'جهة اتصال',
  stopBotFromMe: 'ايقاف البوت عند الرد من خلالي',
  timeToRestartBot: 'وقت اعادة تشغيل البوت بعد اخر رد من خلالي ( بالثواني )',
  for_campaign: 'الحملة الاعلانية :campaign ',
  loading_campaign: 'جاري تحميل الحملة الاعلانية ...',
  gotToHome: 'الرجوع للرئيسية',
  payment_success_button: 'عرض لوحة التحكم',
  payment_success_title: 'تم الدفع بنجاح!',
  payment_success_message: 'شكرًا لك، تم إتمام عملية الدفع بنجاح، وتم تفعيل اشتراكك.',
  _payment_success_button: 'العودة إلى الصفحة الرئيسية',
  payment_fail_title: 'فشلت عملية الدفع',
  payment_fail_message:
    'نأسف، لم تتم عملية الدفع بنجاح. الرجاء المحاولة مرة أخرى أو استخدام وسيلة دفع مختلفة.',
  payment_fail_button: 'العودة للمحاولة مرة أخرى',
  loading_checkout_page: 'ثواني ونوصلك لخطوتك الأخيرة… اشتراكك يبدأ من هنا',
  bot_messages: 'رسائل البوت',
  auto_responder_messages: 'رسائل الرد التلقائي',
  api_messages: 'رسائل API',
  campaign_messages: 'رسائل الحملات',
  templates_list: 'قوائم القوالب',
  templates_text_media: 'قوائم القوالب',
  current_users: 'المستخدمين الحاليين',
  current_subscription_details: 'تفاصيل الاشتراك الحالي',
  success_messages: 'رسائل النجاح',
  failed_messages: 'رسائل الفشل',
  accounts_stats: 'إحصائيات الحسابات',
  transactions_subscription: 'اشتراكات التسجيلات',
  transactions_subscription_description: 'اشتراكات التسجيلات',
  transactions_subscription_title: 'اشتراكات التسجيلات',
  transactionsSubscription: 'اشتراكات التسجيلات',
  third_party_id: 'رقم عملية الدفع ',
  amount: 'السعر',
  customer: 'العميل',
  transaction_details: 'تفاصيل العملية',
  payment_card_info: 'معلومات البطاقة',
  card_number: 'رقم البطاقة',
  card_type: 'نوع البطاقة',
  card_holder_name: 'اسم صاحب البطاقة',
  expiry_date: 'تاريخ انتهاء الصلاحية',
  transaction_logs: 'سجل العمليات',
  back: 'رجوع',
  completed: 'مكتمل',
  pending: 'قيد الانتظار',
  log_entry: 'سجل',
  payload: 'payload',
  response: 'response',
  notes: 'ملاحظات',
  ip_address: 'عنوان IP',
  user_agent: 'User Agent',
  transaction_id: 'رقم العملية',
  user_info: 'معلومات المستخدم',
  plan_details: 'تفاصيل الاشتراك',
  payment_details: 'تفاصيل الدفع',
  card_info: 'معلومات البطاقة',
  notify_user: 'إشعار المستخدم',
  plan_features: 'مميزات الاشتراك',
  logs_details: 'تفاصيل السجل',
  card: 'بطاقة',
  gateway: 'بوابة',
  method: 'طريقة الدفع',
  plan_name: 'اسم الخطة',
  event_type: 'نوع الحدث',
  refunded: 'إرجاع',
  canceled: 'إلغاء',
  success: 'مكتمل',
  plan_ends_at: 'تنتهي الخطة في',
  change_subscription: 'تغيير الخطة',
  success_change_subscription: 'تم تغيير الخطة بنجاح',
  max_whatsapp_accounts: 'الحد الأقصى لحسابات الواتساب',
  max_whatsapp_messages: 'الحد الأقصى لرسائل الواتساب',
  contacts_enabled: '  جهات الاتصال',
  groups_enabled: 'مجموعات جهات الاتصال',
  send_message_history: 'سجل الرسائل',

  send_button_message: 'رسالة زر',
  send_document_message: 'رسالة وثيقة',
  send_api_request: 'إرسال طلب API',
  send_video_message: 'رسالة فيديو',
  send_audio_message: 'رسالة صوت',
  send_sticker_message: 'رسالة استيكر',

  url_shortener_enabled: 'اختصار الروابط',
  max_blacklist_numbers: 'الحد الأقصى للقائمة السوداء ',
  max_whatsapp_groups: 'الحد الأقصى مجموعات الواتساب',
  max_chatbot_items: 'الحد الأقصى للشات بوت',
  max_contacts: 'الحد الأقصى لجهات الاتصال',
  api_webhook_enabled: 'API Webhook',
  blacklist_enabled: 'القائمة السوداء ',
  max_shortened_urls: 'الحد الأقصى لاختصار الروابط',
  send_text_message: 'إرسال رسالة نصية',
  send_contact_message: 'إرسال رسالة جهة اتصال',
  send_media_message: 'إرسال رسالة وسائط',
  send_poll_message: 'إرسال رسالة استطلاع الرأي',
  send_list_message: 'إرسال رسالة قائمة',
  send_location_message: 'إرسال رسالة موقع',
  send_ptv_message: 'إرسال رسالة PTV',
  send_status_message: 'إرسال رسالة حالة',
  campaigns_enabled: 'حملات الإعلانية',
  max_campaigns_in_same_time: 'الحد الأقصى للحملات',
  whatsapp_groups_enabled: 'مجموعات الواتساب',
  chatbot_enabled: 'شات بوت',
  max_contacts_groups: 'الحد الأقصى لجهات الاتصال',
  contacts_groups_enabled: 'مجموعات جهات الاتصال',
  logout: 'تسجيل الخروج',
  hello: 'مرحباً',
  subscription_status: 'حالة الاشتراك',
  active: 'نشط',
  expired: 'منتهي',
  manage_subscription: 'إدارة الاشتراك',
  renew_subscription: 'تجديد الاشتراك',
  starts_at: 'بدأ الباقة',
  ends_at: 'انتهاء الباقة',
  total: 'الاجمالي',
  sent_messages: 'رسائل المرسل',
  buttonMessage: 'رسالة زر',
  buttonMessageDescription: 'رسالة زر',
  footer: 'نهاية الرسالة',
  addButton: 'إضافة زر',
  removeButtons: 'إزالة زر',
  displayText: 'نص الزر',
  reply: 'رد',
  url: 'رابط',
  call: 'اتصال',
  notifications: 'الإشعارات',
  new: 'جديد',
  no_data_available: 'لا توجد بيانات',
  load_more_notifications: 'تحميل المزيد من الإشعارات',
  resetSessionAfter: 'إعادة تشغيل البوت من البداية بعد (بالثواني)',
  botSettings: 'إعدادات البوت',
  auto_login: 'تسجيل الدخول تلقائي',
  back_to_admin: 'العودة لللوحة التحكم  ',
  you_can_make_refresh_to_try_get_name_account: 'يمكنك تحديث الحساب لمحاولة الحصول على اسم الحساب',
  no_active_subscription_message: 'لا يوجد لديك اشتراك حالي',
  subscribe_now: 'اشترك الآن',
  stopCampaign: 'إيقاف الحملة',
  restartCampaign: 'إعادة تشغيل الحملة',
  phone_not_valid: 'رقم الهاتف غير صحيح',
  email_not_valid: 'البريد الالكتروني غير صحيح',
  force_renew: 'تجديد الباقة',
  add_section: 'إضافة قسم',
  row_title: 'عنوان الصف',
  row_description: 'وصف الصف',
  sections: 'الأقسام',
  section: 'القسم',
  rows: 'الصفوف',
  row: 'الصف',
  max_sections_reached: 'تم الوصول للحد الأقصى من الأقسام (6)',
  section_title: 'عنوان القسم',
  remove_section: 'حذف القسم',
  remove_row: 'حذف الصف',
  // button_text: 'نص الزر',
  footer_text: 'نص التذييل',
  add_row: 'إضافة صف',
  add_keyword: 'إضافة ',
  keyword: 'الكلمة المفتاحية',
  generateToken: 'توليد Token',
  finishKeyword: 'كلمة انتهاء البوت',
  max_tokens: 'أقصى طول للإجابة',
  temperature: 'تنوع الإجابة',
  model: 'نموذج',
  promptsAi: 'AI prompts',
  keyToSave: 'الكود للحفظ',
  keyToSavePlaceholder: 'الكود للحفظ',
  saveVariable: 'حفظ المتغير',
  chatGptNode: 'ذكاء اصطناعي ',
  finishNode: 'نهاية البوت',
  // selectAPrompt: 'اختر موجه',
  finishKeywordMatchType: 'نوع مطابقة كلمة انتهاء البوت',
  anyMessage: 'أي نص آخر',
  upgradePackage: 'ترقية الباقة',

  // Short Codes
  short_codes: {
    available_codes: 'الرموز المختصرة المتاحة',
    click_to_insert: 'انقر لإدراج في موضع المؤشر',
    codes: 'رموز',
    usage_hint: 'انقر على أي رمز مختصر أعلاه لإدراجه في رسالتك في موضع المؤشر الحالي',

    // Customer Information
    customer_name: 'اسم العميل',
    customer_phone: 'جوال العميل',
    customer_email: 'بريد العميل',
    customer_country: 'دولة العميل',
    customer_city: 'مدينة العميل',
    customer_number: 'رقم العميل',
    activation_code: 'رمز التفعيل',

    // Abandoned Cart Information
    cart_number: 'رقم السلة',
    cart_total: 'اجمالي السلة',
    cart_age_minutes: 'عمر السلة بالدقائق',
    cart_creation_date: 'تاريخ إنشاء السلة',
    cart_update_date: 'تاريخ تحديث السلة',
    cart_products_count: 'عدد منتجات السلة',

    // Review Information
    rating: 'التقييم',
    comment: 'التعليق',
    review_date: 'تاريخ التقييم',
    customer_name_review: 'اسم عميل',
    customer_phone_review: 'جوال عميل',
    coupon: 'الكوبون',

    // Store Information
    store_name: 'اسم المتجر',

    // Order Information
    order_number: 'رقم الطلب',
    order_status: 'حالة الطلب',
    order_total: 'اجمالي الطلب',
    order_date: 'تاريخ الطلب',
    subtotal: 'المجموع الفرعي',
    shipping_cost: 'تكلفة الشحن',
    tax_amount: 'مبلغ الضريبة',
    total_amount: 'المبلغ الإجمالي',

    // Shipping Information
    shipping_company: 'شركة الشحن',
    recipient_name: 'اسم المستلم',
    recipient_email: 'بريد المستلم',
    recipient_phone: 'جوال المستلم',
    shipping_address: 'عنوان الشحن',
    shipping_city: 'مدينة الشحن',
    shipping_country: 'دولة الشحن',
    postal_code: 'الرمز البريدي',
    tracking_number: 'رقم الشحنة',

    // Links
    tracking_link: 'رابط التتبع',
    order_link: 'رابط الطلب',
    admin_link: 'رابط الإدارة',
    review_link: 'رابط التقييم',
    payment_link: 'رابط الدفع',
  },

  // Zid Integration
  zid_integration: 'تكامل زد',
  zid_integration_description: 'دمج متجر زد الخاص بك مع لوحة تحكم راسل',
  zid_coming_soon: 'قريباً',
  zid_coming_soon_description:
    'تكامل زد قيد التطوير حالياً. نحن نعمل بجد لتقديم تجربة تكامل سلسة لك.',

  // Shopify Integration
  shopify_integration: 'تكامل شوبيفاي',
  shopify_integration_description: 'دمج متجر شوبيفاي الخاص بك مع لوحة تحكم راسل',
  shopify_coming_soon: 'قريباً',
  shopify_coming_soon_description:
    'تكامل شوبيفاي قيد التطوير حالياً. نحن نعمل بجد لتقديم تجربة تكامل سلسة لك.',

  // Common Integration Features
  easy_setup: 'إعداد سهل',
  easy_setup_description: 'عملية تكامل بسيطة مع متجرك',
  powerful_tools: 'أدوات قوية',
  powerful_tools_description: 'إدارة حملات متقدمة وتحليلات',
  zid_native: 'زد الأصلي',
  zid_native_description: 'مبني خصيصاً لمنصة زد',
  shopify_native: 'شوبيفاي الأصلي',
  shopify_native_description: 'مبني خصيصاً لمنصة شوبيفاي',

  you_can_edit: 'يمكنك تعديل البيانات',
  // Template selection
  choose_template: 'اختر القالب',
  select_template_or_manual: 'اختر قالب أو أضف يدوياً',
  refresh_templates: 'تحديث القوالب',
  template_loaded: 'تم تحميل القالب',
  clear_template: 'مسح القالب',

  // Bot Builder Nodes
  conversation_end: 'نهاية المحادثة',
  finish_node_description:
    'هذه العقدة تمثل نهاية تدفق المحادثة. سيتوقف البوت عن الرد بعد هذه النقطة.',
  bot_will_stop: 'سيتوقف البوت عن الرد بعد هذه العقدة.',
  remove_node: 'إزالة العقدة',
  // start_node: 'البداية',
  start_node_description: 'هذه هي نقطة البداية لتدفق الشات بوت.',
  text_message_description: 'إرسال رسالة نصية بسيطة للمستخدم.',
  image_message: 'رسالة صورة',
  image_message_description: 'إرسال صورة مع نص توضيحي اختياري.',
  video_message: 'رسالة فيديو',
  video_message_description: 'إرسال فيديو مع نص توضيحي اختياري.',
  audio_message: 'رسالة صوتية',
  audio_message_description: 'إرسال ملف صوتي مع نص توضيحي اختياري.',
  document_message: 'رسالة مستند',
  document_message_description: 'إرسال ملف مستند مع نص توضيحي اختياري.',
  location_message: 'رسالة موقع',
  location_message_description: 'إرسال موقع للمستخدم.',
  contact_message: 'رسالة جهة اتصال',
  contact_message_description: 'إرسال معلومات جهة اتصال للمستخدم.',
  sticker_message: 'رسالة ملصق',
  sticker_message_description: 'إرسال ملصق للمستخدم.',
  button_message: 'رسالة أزرار',
  button_message_description: 'إرسال رسالة مع أزرار تفاعلية.',
  list_message: 'رسالة قائمة',
  list_message_description: 'إرسال رسالة مع قائمة خيارات.',
  api_request: 'طلب API',
  api_request_description: 'إجراء طلب API ضمن تدفق البوت.',
  chatgpt_node: 'ChatGPT',
  chatgpt_node_description: 'التكامل مع ChatGPT للردود الذكية.',
  save_variable: 'حفظ متغير',
  save_variable_description: 'حفظ متغير من إدخال المستخدم.',
  upload_file: 'رفع ملف',
  enter_url: 'أدخل الرابط',
  caption: 'نص توضيحي',
  enter_caption: 'أدخل نص توضيحي',
  enter_text: 'أدخل نص الرسالة',
  enter_title: 'أدخل العنوان',
  enter_description: 'أدخل الوصف',
  enter_name: 'أدخل الاسم',
  enter_phone: 'أدخل رقم الهاتف',
  enter_email: 'أدخل البريد الإلكتروني',
  enter_company: 'أدخل اسم الشركة',
  enter_job_title: 'أدخل المسمى الوظيفي',
  enter_address: 'أدخل العنوان',
  enter_latitude: 'أدخل خط العرض',
  enter_longitude: 'أدخل خط الطول',
  enter_url_placeholder: 'أدخل الرابط (مثال: https://example.com)',
  enter_phone_placeholder: 'أدخل رقم الهاتف (مثال: +1234567890)',
  enter_email_placeholder: 'أدخل البريد الإلكتروني',
  enter_name_placeholder: 'أدخل اسم جهة الاتصال',
  enter_company_placeholder: 'أدخل اسم الشركة',
  enter_job_title_placeholder: 'أدخل المسمى الوظيفي',
  enter_address_placeholder: 'أدخل العنوان',
  enter_latitude_placeholder: 'أدخل إحداثي خط العرض',
  enter_longitude_placeholder: 'أدخل إحداثي خط الطول',
  drag_drop_file: 'اسحب وأفلت ملف هنا، أو انقر للاختيار',
  drag_drop_image: 'اسحب وأفلت صورة هنا، أو انقر للاختيار',
  drag_drop_video: 'اسحب وأفلت فيديو هنا، أو انقر للاختيار',
  drag_drop_audio: 'اسحب وأفلت ملف صوتي هنا، أو انقر للاختيار',
  drag_drop_document: 'اسحب وأفلت مستند هنا، أو انقر للاختيار',
  drag_drop_sticker: 'اسحب وأفلت ملصق هنا، أو انقر للاختيار',
  temperature_description: 'تتحكم في عشوائية رد الذكاء الاصطناعي',
  select_model: 'اختر نموذج الذكاء الاصطناعي',
  prompt: 'الموجه',
  enter_prompt: 'أدخل الموجه للذكاء الاصطناعي',
  enter_max_tokens: 'أدخل الحد الأقصى لعدد الرموز',
  api_url: 'رابط API',
  enter_api_url: 'أدخل رابط نقطة نهاية API',
  api_method: 'الطريقة',
  select_method: 'اختر طريقة HTTP',
  api_headers: 'الترويسات',
  api_body: 'المحتوى',
  api_response: 'الاستجابة',
  api_status: 'الحالة',
  api_timeout: 'المهلة الزمنية',
  enter_timeout: 'أدخل المهلة الزمنية بالثواني',
  variable_name: 'اسم المتغير',
  enter_variable_name: 'أدخل اسم المتغير',
  variable_value: 'قيمة المتغير',
  enter_variable_value: 'أدخل القيمة المراد حفظها',

  // Additional Bot Builder Keys
  focused: 'مركز',
  creative: 'خلاق',
  gpt_node_info:
    'تتكامل هذه العقدة مع ChatGPT لتوفير ردود ذكية بناءً على الموجه المحدد وإعدادات النموذج.',
  selectAPrompt: 'اختر موجه',
  insert_emoji: 'إدراج رمز تعبيري',
  // addOption: 'إضافة خيار',
  enter_option_text: 'أدخل نص الخيار',
  // anyMessage: 'أي رسالة',
  no_options_added: 'لم يتم إضافة خيارات بعد',
  add_options_to_continue: 'أضف خيارات للمتابعة',

  // Bot Builder Categories
  category_messages: 'الرسائل',
  category_flow_control: 'تحكم التدفق',
  category_integrations: 'التكاملات',
  category_data: 'البيانات',
  category_other: 'أخرى',

  // Video Tutorial
  watchTutorial: 'شاهد الشرح',
  howItWorks: 'كيف يعمل',
  websiteTutorial: 'شرح الموقع',
  tutorialDescription: 'تعلم كيفية استخدام منصتنا',
  tutorialDescriptionText: 'سيوجهك هذا الفيديو عبر الميزات الرئيسية ويساعدك على البدء مع منصتنا.',
  hour: 'ساعة',
  api_response_info: 'يمكن الوصول إلى بيانات استجابة API باستخدام متغيرات مثل',
  http_method: 'طريقة HTTP',
  headers: 'الترويسات',
  body_parameters: 'معاملات الجسم',
  test_api: 'اختبار API',
  testing: 'اختبار',
  add: 'إضافة',
  key: 'مفتاح',
  value: 'قيمة',
  enter_keyword: 'أدخل الكلمة المفتاحية',
  match_type: 'نوع المطابقة',

  // API Token Page
  api_token_management: 'إدارة رمز API',
  api_token_description: 'إدارة رموز API الخاصة بك للوصول الآمن إلى خدماتنا',
  security_warning: 'تحذير أمني',
  api_token_security_note:
    'احتفظ برمز API الخاص بك آمناً ولا تشاركه علناً أبداً. قم بتجديده إذا تم اختراقه.',
  your_api_token: 'رمز API الخاص بك',
  api_token_subtitle: 'استخدم هذا الرمز للمصادقة على طلبات API',
  api_token: 'رمز API',
  no_token_generated: 'لم يتم توليد رمز بعد',
  // copied: 'تم النسخ',
  // copy: 'نسخ',
  regenerating: 'جاري التجديد...',
  view_api_docs: 'عرض وثائق API',
  how_to_use: 'كيفية الاستخدام',
  api_token_usage_instructions: 'قم بتضمين هذا الرمز في رأس Authorization لطلبات API الخاصة بك',
  best_practices: 'أفضل الممارسات',
  api_token_best_practices:
    'احفظ الرموز بأمان، وقم بتدويرها بانتظام، ولا تضعها في نظام التحكم في الإصدارات',
  copied_to_clipboard: 'تم النسخ إلى الحافظة',
  failed_to_copy: 'فشل في النسخ',

  // Package Page
  subscription_overview: 'نظرة عامة على الاشتراك',
  subscription_overview_description: 'عرض وإدارة تفاصيل وميزات اشتراكك الحالي',
  // no_active_subscription: 'لا يوجد اشتراك نشط',
  subscription_required_message: 'تحتاج إلى اشتراك نشط للوصول إلى الميزات المميزة',
  choose_plan: 'اختر الخطة',
  // trial_period: 'فترة التجربة',
  // status_ended: 'منتهي',
  // status_trial: 'تجريبي',
  // status_active: 'نشط',
  // upgrade_plan: 'ترقية الخطة',
  // price: 'السعر',
  // billing_cycle: 'دورة الفوترة',
  // start_date: 'تاريخ البدء',
  // end_date: 'تاريخ الانتهاء',
  // subscription_title: 'ميزات الخطة',
  // not_enabled: 'غير مفعل',
  // enabled: 'مفعل',

  // QR Code Page
  connection_steps: 'خطوات الاتصال',
  alternative_login: 'تسجيل الدخول البديل',
  qr_code_alternative_description:
    'إذا واجهت مشكلة في مسح رمز QR، يمكنك استخدام طريقة التحقق من رقم الهاتف أدناه.',
  scan_qr_code: 'امسح رمز QR',
  qr_code_loading: 'جاري تحميل رمز QR...',
  regenerate_qr: 'إعادة توليد رمز QR',
  qr_code_expires_in: 'ينتهي رمز QR خلال 30 ثانية',

  // PM2 Monitor
  pm2: {
    process_monitor: 'مراقب عمليات PM2',
    monitor_and_manage_processes: 'راقب وأدر عمليات PM2 الخاصة بك في الوقت الفعلي',
    auto_refresh: 'تحديث تلقائي',
    interval: 'الفترة الزمنية',
    refresh: 'تحديث',
    refreshing: 'جاري التحديث...',
    processes: 'العمليات',
    loading_processes: 'جاري تحميل العمليات...',
    no_processes_found: 'لم يتم العثور على عمليات',
    start_pm2_processes: 'ابدأ بعض عمليات PM2 لرؤيتها هنا',
    cpu: 'المعالج',
    memory: 'الذاكرة',
    uptime: 'وقت التشغيل',
    restarts: 'إعادة التشغيل',
    restart: 'إعادة تشغيل',
    stop: 'إيقاف',
    start: 'بدء',
    delete: 'حذف',
    details: 'التفاصيل',
    select_process: 'اختر عملية',
    status: 'الحالة',
    process_id: 'معرف العملية',
    cpu_usage: 'استخدام المعالج',
    exec_path: 'مسار التنفيذ',
    working_directory: 'المجلد العامل',
    recent_logs: 'السجلات الحديثة',
    no_logs_available: 'لا توجد سجلات متاحة',
    choose_process_from_list: 'اختر عملية من القائمة لعرض المعلومات التفصيلية والسجلات',
    error: 'خطأ',
    to_fix_this_issue: 'لحل هذه المشكلة',
    install_pm2_globally: 'تثبيت PM2 عالمياً',
    or_add_pm2_to_path: 'أو أضف PM2 إلى مسار النظام',
    or_restart_server: 'أو أعد تشغيل الخادم بعد تثبيت PM2',
  },

  scheduled: 'مجدول',
  delivered: 'تم التسليم',
  read: 'تم القراءة',
  text_media: 'نص / وسائط',

  // Contacts Management
  contacts_management: 'إدارة جهات الاتصال',
}
